export default __webpack_public_path__ + "static/media/logo-transitar-gray90.24b0c4cc.png";